const windowPopUp = (url, width, height) => {
    /* eslint-disable no-undef */
    let screenX = typeof window.screenX != 'undefined' ? window.screenX : window.screenLeft;
    let screenY = typeof window.screenY != 'undefined' ? window.screenY : window.screenTop;
    let outerWidth =
        typeof window.outerWidth != 'undefined' ? window.outerWidth : document.body.clientWidth;
    let outerHeight =
        typeof window.outerHeight != 'undefined'
            ? window.outerHeight
            : document.body.clientHeight - 22;
    let left = parseInt(screenX + (outerWidth - width) / 2, 10);
    let top = parseInt(screenY + (outerHeight - height) / 2.5, 10);
    let settings = `width=${width},height=${height},left=${left},top=${top}`;
    let newWindow = window.open(url, '', settings);
    if (window.focus) newWindow?.focus();
    return newWindow;
    /* eslint-enable no-undef */
};

export { windowPopUp };
